import { render } from "./TeacherTemp.vue?vue&type=template&id=69e55f00&scoped=true"
import script from "./TeacherTemp.vue?vue&type=script&lang=js"
export * from "./TeacherTemp.vue?vue&type=script&lang=js"

import "./TeacherTemp.vue?vue&type=style&index=0&id=69e55f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e55f00"]])

export default __exports__